export var isGuestRoute = function (allowedRoutes) {
    if (allowedRoutes === void 0) { allowedRoutes = []; }
    var finded = allowedRoutes.find(function (r) { return r === window.location.pathname; });
    if (finded) {
        return true;
    }
    return false;
};
//# sourceMappingURL=guestHelpers.js.map